import { useViewport } from 'contexts/viewport';
import { forwardRef } from 'react';
import { Dialog, Drawer } from 'shell/components';

export default forwardRef((props, ref) => {
    const { device } = useViewport();

    return device === 'mobile' ? <Drawer ref={ref} {...props} device={device} /> : <Dialog ref={ref} {...props} />;
});
